import { Box, Skeleton } from "@mui/material";

export const ChartSkeleton = () => (
  <Box height={240} display="flex" flexDirection="column" gap={2}>
    <Skeleton variant="rectangular" width={120} height={20} />
    <Skeleton variant="rectangular" width="100%" height={200} sx={{ borderRadius: 1 }} />
  </Box>
);

export const MetricBarsSkeleton = () => (
  <Box height={240} display="flex" flexDirection="column" gap={2}>
    <Skeleton variant="rectangular" width={120} height={20} />
    <Box display="flex" flexDirection="column" gap={2} mt={2}>
      {[...Array(6)].map((_, index) => (
        <Box key={index} display="flex" alignItems="center" gap={2}>
          <Skeleton variant="rectangular" width={80} height={16} />
          <Skeleton variant="rectangular" width="100%" height={16} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rectangular" width={60} height={16} />
        </Box>
      ))}
    </Box>
  </Box>
);

export const CollaboratorBarsSkeleton = () => (
  <Box height={480} display="flex" flexDirection="column" gap={2}>
    <Skeleton variant="rectangular" width={120} height={20} />
    <Box display="flex" flexDirection="column" gap={2} mt={2}>
      {[...Array(12)].map((_, index) => (
        <Box key={index} display="flex" alignItems="center" gap={2}>
          <Skeleton variant="rectangular" width={120} height={16} />
          <Skeleton variant="rectangular" width="100%" height={16} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rectangular" width={60} height={16} />
        </Box>
      ))}
    </Box>
  </Box>
);

export const DonutChartSkeleton = () => (
  <Box height={240} display="flex" gap={4}>
    <Box flex={1} display="flex" alignItems="center" justifyContent="center">
      <Skeleton variant="circular" width={160} height={160} />
    </Box>
    <Box width={120} display="flex" flexDirection="column" gap={2} mt={4}>
      <Skeleton variant="rectangular" width={100} height={20} />
      <Skeleton variant="rectangular" width={120} height={16} />
      <Skeleton variant="rectangular" width={120} height={16} />
    </Box>
  </Box>
); 